define('views/ui/AutocompleteLineView',['underscore','jquery','backbone','app','template!blocks/address-autocomplete-line','CSS3Events'], function (_,$,Backbone,app,addressAutocompleteLineTemplate,CSS3Events) {

    var AutocompleteLineView = Backbone.View.extend({
        tagName:'li',
        className:'autocomplete-line',
        events:{
            'click button':'selectLine',
            'mouseenter button':'hover',
            'mouseleave button':'hover'
        },
        initialize: function () {

            var view = this,
                model = view.model;
            model.attachToView();
            view.update();
            //view.render();
            view.listenTo(model,'sync',view.onModelChange);
        },
        setup:function(){
            this.render();
        },
        isVAE:function(){
            return this.model.isStore();
        },
        update:function(){
            var view = this,
                model = view.model,
                fetching = model.isFetching(),
                $el = view.$el;
            $el.toggleClass('isValid',model.isValid());
            $el.toggleClass('fetching',fetching);
            $el.toggleClass('no-fetching',!fetching);
        },
        render:function(){
            var view = this;
            view.$el.html(addressAutocompleteLineTemplate(view.model));
            view.delegateEvents();
        },
        remove:function(){
            Backbone.View.prototype.remove.apply(this);
        },
        onModelChange:function(model){
            var view = this,
                place = model.getPlace(),
                store = model.getStore();
            view.$el.removeClass('fetching');
            if(model.isValid()){
                view.$el.removeClass('invalid');
                if(store){
                    view.$('.store').text(store.getFullName());
                }
            }
            if(!model.displayDelay()){
                // do nothing
            }
            view.$('button').attr('class','btn '+model.getTypes().join(' '));
            //
            if(model.isAddress()){
                var isRoute = model.isRoute();
                view.$('.missing-street-number').toggleClass('active',isRoute);
                view.$('.locality-ignored').toggleClass('active',!model.isLocalityMatching() && !isRoute);
            }
            //
            if(model.displayDelay() && model.isValid()){
                view.$('.clock-animate').removeClass('loading');
                if(model.isStoreOpened()){
                    view.$('.estimated-time .value').text(model.formatDelay());
                    //view.$('.clock-animate').removeClass('loading');
                }else if(model.isStore()){
                    view.$('.estimated-time .value').text(model.formatStoreOpening());
                }else{
                    view.removeEstimatedTime();
                }
            }else{
                view.removeEstimatedTime();
            }
        },
        removeEstimatedTime:function(){
            var estimatedTimeEl = this.$('.estimated-time');
            estimatedTimeEl.one(CSS3Events('transitionend'),function(){
                estimatedTimeEl.remove();
            });
            estimatedTimeEl.addClass('fadeout');
        },
        selectLine:function(){
            var view = this;
            view.trigger('selectAutocompleteLine',view.model);
            // 
            // 
        },
        hover:function(e){
            var view = this;
            view.trigger('hover',view,e.type == 'mouseenter',e);
        }

    });

    return AutocompleteLineView;
});
